import { check } from './validate';

const currencyOrEmptyValidators = {
  isFloatNumberOrEmpty: value => value === '' || !isNaN(parseFloat(value)),
  matchRegex: value => /^((?!\.)|0|[1-9]\d*)(\.\d{0,2})?$/.test(value)
};

export const isAmountDecimalOrEmpty = value => check(value, currencyOrEmptyValidators).length === 0;

export default { isAmountDecimalOrEmpty };
